/**
 * Build a jetton transfer payload for TonConnect.
 * Uses @ton/core for correct cell serialization.
 */
import { beginCell, Address, toNano } from '@ton/core';

export function buildJettonTransferPayload(amountNano, toAddress) {
  try {
    const destAddr = Address.parse(toAddress);

    const body = beginCell()
      .storeUint(0xf8a7ea5, 32)       // op: jetton transfer
      .storeUint(0, 64)               // query_id
      .storeCoins(BigInt(amountNano)) // amount
      .storeAddress(destAddr)         // destination (prize pool)
      .storeAddress(destAddr)         // response_destination
      .storeBit(0)                    // no custom_payload
      .storeCoins(toNano('0.01'))     // forward_ton_amount
      .storeBit(0)                    // no forward_payload
      .endCell();

    const boc = body.toBoc();

    // Convert Uint8Array to base64
    if (typeof Buffer !== 'undefined') {
      return Buffer.from(boc).toString('base64');
    }
    let binary = '';
    const bytes = new Uint8Array(boc);
    for (let i = 0; i < bytes.length; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);

  } catch (e) {
    console.error('buildJettonTransferPayload error:', e);
    throw new Error('Failed to build transfer: ' + e.message);
  }
}

export async function getUserJettonWallet(ownerAddress, jettonMaster) {
  const res = await fetch(
    `https://tonapi.io/v2/accounts/${encodeURIComponent(ownerAddress)}/jettons/${encodeURIComponent(jettonMaster)}`,
    { headers: { Accept: 'application/json' } }
  );
  if (!res.ok) throw new Error('Could not fetch jetton wallet');
  const data = await res.json();

  // TonAPI returns raw address, convert to user-friendly bounceable format
  const rawAddress = data.wallet_address?.address;
  if (!rawAddress) throw new Error('No jetton wallet found');

  // Parse and convert to bounceable format
  try {
    const addr = Address.parse(rawAddress);
    return addr.toString({ bounceable: true });
  } catch {
    return rawAddress;
  }
}
